export default {"src":"/_next/static/media/fh_black_logo.7117914e.svg","height":56,"width":150,"blurWidth":0,"blurHeight":0};